export class Argument {
    constructor(
        public id: string,
        public name: string
    ) {
    }
}
